<template>
  <div class="container bottom">
    <div class="mid-container">

<div class="popup">
  <form v-if="sendingState === 0">

    <div class="message-root-container" v-if="!showSpeedDialEditor">

      <div class="message-container">

         <div class="pep-speedDial">
           <img class="opacityHalf pointer" v-on:click="switchShowSpeedDialEdit()" src="../img/ic_routeoptions_edit.svg" width="48px" height="48px">
            <img class="opacityThreeQ pointer" v-on:click="speedDialClicked(0)" src="../img/speedDial/0.svg" width="48px" height="48px">
            <img class="opacityThreeQ pointer" v-on:click="speedDialClicked(1)" src="../img/speedDial/1.svg" width="48px" height="48px">
            <img class="opacityThreeQ pointer" v-on:click="speedDialClicked(2)" src="../img/speedDial/2.svg" width="48px" height="48px">
            <img class="opacityThreeQ pointer" v-on:click="speedDialClicked(3)" src="../img/speedDial/3.svg" width="48px" height="48px">
            <img class="opacityThreeQ pointer" v-on:click="speedDialClicked(4)" src="../img/speedDial/4.svg" width="48px" height="48px">
        </div>


        <div class="text-container">

          <div class="pep-input" v-show="textChosen">
            <textarea class="popup-input" style="margin-bottom: 0px; background-color:white;" rows="7" type="text" v-model="message" @input="autoLanguageDetect" v-on:keyup.enter="confirm" autofocus :maxlength="charLimit" placeholder="Your Message" :readonly="fileSelected"></textarea>
          </div>

          <label class="char-warning" v-show="textChosen">{{(charLimit - message.length)}} chars left</label>
          <label class="char-warning" v-show="showAdminContent && textChosen" v-on:click="previewAudio()">Preview audio</label>
          <label class="char-warning" v-show="showAdminContent && language">{{language}}</label>


          <input type="file" id="audioUpload" ref="audioUpload" accept="audio/*" v-on:change="onFileChange" v-show="showAdminContent">
          <label class="char-warning" v-show="!textChosen && !fileSending" v-on:click="removeFile">Remove file</label>
          <label class="char-warning" v-show="fileSending">Sending file</label>
          <label class="char-warning" v-show="fileSent">File uploaded successfully!</label>


        </div>

      </div>
    </div>
    <div class="message-root-container" v-if="showSpeedDialEditor">

          <div class="pep-input-row">
          <img src="../img/speedDial/0.svg" width="48px" height="48px">
          <input class="popup-input" type="text" v-model="plannerSpeedDial[0].message" style="margin-left:15px" />
          </div>
           <div class="pep-input-row">
          <img src="../img/speedDial/1.svg" width="48px" height="48px">
          <input class="popup-input" type="text" v-model="plannerSpeedDial[1].message" style="margin-left:15px" />
          </div>
          <div class="pep-input-row">
          <img src="../img/speedDial/2.svg" width="48px" height="48px">
          <input class="popup-input" type="text" v-model="plannerSpeedDial[2].message" style="margin-left:15px" />
          </div>
          <div class="pep-input-row">
          <img src="../img/speedDial/3.svg" width="48px" height="48px">
          <input class="popup-input" type="text" v-model="plannerSpeedDial[3].message" style="margin-left:15px" />
          </div>
          <div class="pep-input-row">
          <img src="../img/speedDial/4.svg" width="48px" height="48px">
          <input class="popup-input" type="text" v-model="plannerSpeedDial[4].message" style="margin-left:15px" />
          </div>
    <!--     <div class="text-container">

          <div class="pep-input" v-show="textChosen">
            <input class="popup-input" style="margin-bottom: 0px; background-color:white;" rows="7" type="text" v-model="message" @input="autoLanguageDetect" v-on:keyup.enter="confirm" autofocus :maxlength="charLimit" placeholder="Your Message" :readonly="fileSelected"></textarea>
          </div>
        </div> -->
    </div>


    <div class="vr-bottom-container">


    <input type="number" v-model="distanceLocation" v-show="isDistance && !showSpeedDialEditor" style="background-color:white;" placeholder="Speak at meters"  />

      <div class="soe-container" v-if="!showSpeedDialEditor">

          <label>Speak on </label>

          <select v-model="soe">
            <option v-for="option in soeOptions" v-bind:value="option.value">
              {{ option.text }}
            </option>
          </select>

        <label>time.</label>

      </div>

      <div class="buttons" v-if="!showSpeedDialEditor">
        <div class="popup-button" v-on:click="remove()">
          <img src="../img/cancel.svg">
          <label>Remove</label>
        </div>

        <div class="popup-button" v-on:click="confirm()">
          <img src="../img/ok.svg">
          <label v-show="textChosen || fileSent">Ok</label>
          <label v-show="textChosen === false && fileSent === false">Send Audio</label>
        </div>
      </div>
      <div class="buttons" v-if="showSpeedDialEditor">
        <div>
        </div>

        <div class="popup-button" v-on:click="switchShowSpeedDialEdit()">
          <img src="../img/ok.svg">
          <label>Ok</label>
        </div>
      </div>
    </div>
  </form>
</div>
    </div></div>

</template>

<script>

import { mapGetters } from 'vuex'
import { store } from '../store/store'
import firebase from 'firebase'
import MapManager from '../helpers/mapManager'
import axios from 'axios'
import _ from 'lodash'

export default {
  name: 'pepPoint',
    props: {
    isDistance: Boolean
  },

//      speedDial: [{message: 'vasen', index:0 }, {message: 'suoraan vasemmalle', index: 1}, {message: 'suoraan', index: 2}, {message: 'suoraan oikealle', index:3 }, {message: 'oikealle', index: 4 }],

  data() {
    return {
      //soeSelected: 1,
      soeOptions: [
        { text: '1st', value: 1 },
        { text: '2nd', value: 2 },
        { text: '3rd', value: 3 },
        { text: '4th', value: 4 },
        { text: '5th', value: 5 },
        { text: '6th', value: 6 },
        { text: '7th', value: 7 },
        { text: '8th', value: 8 },
        { text: '9th', value: 9 },
        { text: '10th', value: 10 }
      ],
      plannerSpeedDial: [
        { message: '', index: 0} , { message: '', index: 1}, { message: '', index: 2}, { message: '', index: 3}, { message: '', index: 4}
      ],
      sendingState: 0,
      textChosen: true,
      sender: '',
      charLimit: 500,
      vmr: {status: 0},
      fileSelected: false,
      file: '',
      fileSent: false,
      fileSending: false,
      showSpeedDialEditor: false

    }
  },
  computed: {
    ...mapGetters([ 'selectedPepPointId', 'selectedPepPoint', 'selectedDistancePepPoint', 'currentRaceId']),
    message: {
      get: function() {

        console.log(this.isDistance)
        if (this.isDistance) {
        if(this.$store.getters.selectedDistancePepPoint) {
          return this.$store.getters.selectedDistancePepPoint.message
        } else {
          return ''
        }
        } else {
        if(this.$store.getters.selectedPepPoint) {
          return this.$store.getters.selectedPepPoint.message
        } else {
          return ''
        }
        }

      },
      set: function(value) {
        this.$store.dispatch('updatePepText', { message: value, path: this.isDistance ? 'racePepPointsWoLocation' : 'racePepPoints' })
      }
    },
    language: {
 get: function() {
        console.log(this.isDistance)
        if (this.isDistance) {
        if(this.$store.getters.selectedDistancePepPoint) {
          return this.$store.getters.selectedDistancePepPoint.language
        } else {
          return ''
        }
        } else {
        if(this.$store.getters.selectedPepPoint) {
          return this.$store.getters.selectedPepPoint.language
        } else {
          return ''
        }
        }

      },
      set: function(value) {
        console.log('fafa')
      }
    },
    distanceLocation: {
      get: function() {
        if (this.isDistance) {
        if(this.$store.getters.selectedDistancePepPoint) {
          return this.$store.getters.selectedDistancePepPoint.distanceLocation
        } else {
          return ''
        }
        } else {
          return ''

        }
      },
      set: function(value) {
        this.$store.dispatch('updatePepDistance', value)
      }
    },
    soe: {
      get: function() {
        if (this.isDistance) {
          if(this.$store.getters.selectedDistancePepPoint) {
          return this.$store.getters.selectedDistancePepPoint.speakOnEnter
        } else {
          console.log("Speak on enter was not found for current pep point")
          return 1
        }
        } else {
        if(this.$store.getters.selectedPepPoint) {
          return this.$store.getters.selectedPepPoint.speakOnEnter
        } else {
          console.log("Speak on enter was not found for current pep point")
          return 1
        }
        }

      },
      set: function(value) {
        this.$store.dispatch('updatePepSoe', {soe: value, path: this.isDistance ? 'racePepPointsWoLocation' : 'racePepPoints'})
      }
    },
  },
    asyncComputed: {
      showAdminContent() {
        return new Promise((resolve, reject) => {
          firebase.auth().currentUser.getIdTokenResult()
          .then((idTokenResult) => {
            // Confirm the user is an Admin.
            if (idTokenResult.claims.admin) {
             resolve(true)

           } else {
             resolve(false)

           }
          })
          .catch((error) => {
            console.log(error)
            resolve(false)
          })
        })
      }
    },
    mounted() {
      firebase.database().ref('users').child(firebase.auth().currentUser.uid).child('plannerSpeedDial').once('value').then(response => {
        let dataRes = response.val()
        let speedDials = []
        if (dataRes !== null) {
          for (let i = 0; i < 5; i++) {

        if (dataRes.hasOwnProperty(i)) {
         let message = dataRes[i].message
         console.log(message)
         speedDials.push({
           index: i, message: message
         })
       } else {
         speedDials.push({
           index: i, message: ''
         })
       }
       this.plannerSpeedDial = speedDials
    // more statements
}
        }

      })
console.log('joo o')
console.log(this.testi)
    },
  methods: {
    confirm() {

      MapManager.clearSelectedMarker()

      if (this.textChosen || this.fileSent) {
        if (this.textChosen) {

          this.$store.dispatch('requestLanguageDetection', this.isDistance ? 'pepWoLocation' : '')
        }
        this.$store.dispatch('selectPepPoint', '')

      } else {
              this.startSending()
              firebase.auth().currentUser.getIdToken().then((token) => {


                var formData = new FormData();

                formData.append("sender", 'EIOLE')
                if (this.isDistance) {
                formData.append("distanceLocation", this.distanceLocation)
                } else {
                formData.append("latitude", this.selectedPepPoint.location.latitude)
                formData.append("longitude", this.selectedPepPoint.location.longitude)
                }
                formData.append("msg", this.file)
                formData.append('speakOnEnter', 1)
                formData.append('isLive', false)

                var xhr = new XMLHttpRequest();
                var urlEnd = this.isDistance ? '/dod' : ''
                xhr.open("POST", "https://us-central1-racepeps.cloudfunctions.net/eventAdmin/process/" + this.currentRaceId +'/'+ this.selectedPepPointId + urlEnd, true);

                xhr.onload = () => {
                    console.log(xhr)
                    if (xhr.readyState === xhr.DONE) {
                        if (xhr.status === 200) {
                        console.log(`noniin sit`)
                        this.fileSentSuccess()

                          }
                        } else {
                          console.log("Error with voice message")
                        }
                    }

                xhr.onerror = function(err) {
                  console.log("Failed to process audio message");

                }
                xhr.setRequestHeader('Authorization', 'Bearer ' + token)

                xhr.send(formData);
              })
      }
    },
    remove() {
      if (this.isDistance) {
        store.dispatch('removePepPointWoLocation', this.selectedPepPointId)
      } else {
        MapManager.removePepPoint(this.selectedPepPointId)
      }
    },
    chooseMsgType() {
      console.log('dfasds')
    },
    previewAudio() {
      console.log('dfdddasds')
      console.log('Lets prew ', this.message + this.language)
      this.fetchAndPlayMessagePreview()
    },
    getVoice() {
      if (this.language === 'fi-FI' || this.language === 'nb-NO' || this.language === 'sv-SE' || this.language === 'en-US' || this.language === 'en-GB') {
        return {
          "languageCode": this.language,
          "name": this.language + "-Wavenet-A",
        }
      }
      //any other lang
      return {
        "languageCode": this.language
      }
    },
    fetchAndPlayMessagePreview() {
      let delay = 0
      if (!this.language) {
          delay = 2000
        this.$store.dispatch('requestLanguageDetection', this.isDistance ? 'pepWoLocation' : '')
      }
      setTimeout(() => {
      axios.post("https://texttospeech.googleapis.com/v1/text:synthesize?key=AIzaSyCggRP1WVvpGJ-W2qaS26QchiFnEMihsD4",
      {
  "input":{
    ssml: "<speak>" + this.message + "</speak>"
  },
  "voice": this.getVoice(),
  "audioConfig":{
    "audioEncoding":"MP3"
  }
}
      ).then(response => {
        var snd = new Audio("data:audio/wav;base64," + response.data.audioContent)
        snd.play()
      })
      }, delay)




    },
    startSending() {
      this.fileSending = true
    },
    fileSentSuccess() {
      this.fileSending = false
      this.fileSent = true
    },
    onFileChange(e) {
      if (e.target.files.length === 0){
        console.log('ei filuja')
        this.file = ''
        this.fileSelected = false
        this.textChosen = true

      } else {
        console.log('testiss')
        this.file = this.$refs.audioUpload.files[0]
        this.fileSelected = true
        this.textChosen = false
      }
    },
    removeFile() {
      console.log(`testiii`)
      this.$refs.audioUpload.value = ''
      this.file = ''
      this.fileSelected = false
      this.textChosen = true

    },
    switchShowSpeedDialEdit() {
      if (this.showSpeedDialEditor) {
        this.setSpeedDialsToFirebase()
      }
      this.showSpeedDialEditor = !this.showSpeedDialEditor
    },
    speedDialClicked(index) {
      this.message += this.plannerSpeedDial[index].message
      this.$store.dispatch('requestLanguageDetection', this.isDistance ? 'pepWoLocation' : '')
    },
    setSpeedDialsToFirebase() {
      firebase.database().ref('users').child(firebase.auth().currentUser.uid).child('plannerSpeedDial').set(this.plannerSpeedDial)
    },
    autoLanguageDetect: _.debounce(function () {
      if (this.showAdminContent) {
          this.$store.dispatch('requestLanguageDetection', this.isDistance ? 'pepWoLocation' : '')
      }
    }, 1500)
  },


}

</script>

<style lang="scss" scoped>
  @import '../styles/styles.scss';

  @media screen and (min-width: 1140px) {
    .container.bottom {
      width: 450px;
      height: auto;
      padding: 15px;
    }
  }

  .mid-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    text-align: center;
    align-items: center;
    flex: 1;

    input {
      width: 100%;
      padding: 7px;
      border: 2px solid #ccc;
      border-radius: 4px;
    	background-color: #f8f8f8;
    	font-size: $font-medium;
    }

    .button {
      width: 20%;
      align-items: center;

      img {
        height: 35px;
        width: 35px;
      }
    }
  }

  .soe-container {
  	display: flex;
  	flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-top: 10px;

  	label {
  		font-size: 16px;
  		margin-left: 10px;
  		margin-right: 10px;
  	}
}

  .container.bottom {
    border: 3px solid #EFC12F;
    background-color: #F2F2F2;
  }
.popup {
	//padding-left: 5px;
	//padding-right: 5px;
  flex: 1;
  padding: 0px 0px;
	form {
		margin: 0;
	}

	.popup-button {
		display:flex;
		flex-direction: column;
		text-align: center;
	}
}
  .buttons {
	padding-top: 10px;
	width: 100%;
	display: flex;
	justify-content: space-between;
}

.buttons div label {
	font-size: $font-semi;
	color: $greyrace;
	//padding-left: 10px;
	cursor: pointer;
}
.buttons div img {
	width: 30px;
	height: 30px;
	cursor: pointer;
}

.buttons div {
	display: flex;
	align-items: center;
}

.switch-container {
	display:flex;
	flex-direction: row !important;
	width: 100%;
	margin-bottom: 10px;

	.switch {
		display: flex;
		justify-content: center;
		align-items: center;
		flex: 1;
		//border: solid 1px black;
		background-color: $greyest;
		color: white;
		padding-top: 5px;
		padding-bottom: 5px;

		label {
			font-size: 15px;
		}
	}

	.switch.selected {
		background-color: $cyan;
	}
}
.message-container {

}
.pep-input {
	width: 100%;

	label {
		padding-left: 7px;
	  font-size: $font-medium;
	  color: $greyrace;
		//float: right;
	}

	span {
		float: right;
	}

	textarea, input {
		margin-top: 5px;
		margin-bottom: 5px;
		width: 100%;
	  padding: 7px 7px;
	  border: 0;
		background-color: #F2F2F2;
		font-size: $font-medium;
	}

	textarea {
		resize: none;
	}
}
.char-warning {
	font-style: italic;
	padding-left: 7px;
	color: $greyrace;
	font-size: $font-semi;
}
.audio-container {
	height: 100%;
	display: flex;
	justify-content: flex-end;
	flex-direction: column;
	flex: 1;

	.audio-mid-container {
		display: flex;
		flex: 1;
		justify-content: center;
		align-items: center;
	}
}


.audio-container .vr-button {
	display:flex;
	flex-direction: row;
	cursor: pointer;
	background-color: $cyan;
	align-items: center;
	justify-content: space-between;
	width: 60%;
	padding: 3 0 3 0;
	align-self: center;
	border-radius: 10px;
	margin-bottom: 10px;

	label {
		//font-size: $font-semi;
		//color: $greyrace;
		font-size: 18px;
		color: white;
		flex: 3;
	}

	img {
		width: 30px;
		height: 30px;
		flex: 2;
	}
}
.audio-after-record {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-self: center;
	align-items: center;
	width: 100%;
}

.vrm-label {
	font-style: italic;
	padding-left: 7px;
	color: $cyan;
	font-size: $font-medium;
	text-align: center;
}
.trans--grow {
  	-webkit-transition: all 14s ease-in-out;
		transition: all 14s  ease-in-out;
  	width : 0;
}

.recbar {
	position: absolute;
  left: 0px;
  top: 0px;
	z-index: 1;
	background-color:$cyan_20;
}
.label-container {
	position: relative;
	width:100%;
}
.vrm-recorded-button {
	width: 50%;
	cursor: pointer;
	display: flex;
	align-items: center;
	height: 50px;
	flex-direction: row !important;
}

.vrm-recorded-button.second {
	//padding-left: 25px;
	height: 50px;
}

.vrm-recorded-button label {
	font-style: italic;
	color: $greyrace;
	//font-size: $font-semi;
	font-size: 18px;
	//padding-left: 5px;
	cursor: pointer;
	flex: 2;
}

.vrm-recorded-button img {
	width: 50px;
	height: 15px;
	cursor: pointer;
}

.vrm-recorded-button .listening {
	height: 28px;
}

</style>
